import React from 'react';
import AdminManageUserDetails from "../../components/admin/components/AdminManageUserDetails";

const AdminUserDetailsPage = () => {
    return <AdminManageUserDetails />
}

export default AdminUserDetailsPage;